import { Switch as MaterialSwitch } from '@mui/material';
import React from 'react';

import { SwitchProps } from './Switch.props';
import { ColorProps, SizeProps } from '../../../@types/common.type';

export const Switch: React.FC<SwitchProps> = ({
  defaultChecked,
  checked,
  color = ColorProps.Default,
  size = SizeProps.Small,
  onChange,
  onClick,
  disabled,
  testDataId,
  ariaLabel,
}) => {
  // React errors when an input gets both `checked` and `defaultChecked` — it
  // cannot be controlled and uncontrolled at once. Previously both were always
  // passed (each with a `false` default), so every Switch in the app logged a
  // warning. Send exactly one: controlled when the caller supplies `checked`,
  // uncontrolled otherwise. Every production consumer passes `checked`, so
  // rendered behaviour is unchanged.
  const controlledProps =
    checked !== undefined ? { checked } : { defaultChecked: defaultChecked ?? false };

  return (
    <MaterialSwitch
      {...controlledProps}
      color={color}
      size={size}
      onChange={onChange}
      onClick={onClick}
      disabled={disabled}
      inputProps={{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        'data-testid': testDataId,
        ...(ariaLabel ? { 'aria-label': ariaLabel } : {}),
      }}
    />
  );
};
